import { render, staticRenderFns } from "./MenuLandingPageMobile.vue?vue&type=template&id=7848e234&scoped=true"
import script from "./MenuLandingPageMobile.vue?vue&type=script&lang=js"
export * from "./MenuLandingPageMobile.vue?vue&type=script&lang=js"
import style0 from "./MenuLandingPageMobile.vue?vue&type=style&index=0&id=7848e234&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7848e234",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/moderlab/moderclient/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7848e234')) {
      api.createRecord('7848e234', component.options)
    } else {
      api.reload('7848e234', component.options)
    }
    module.hot.accept("./MenuLandingPageMobile.vue?vue&type=template&id=7848e234&scoped=true", function () {
      api.rerender('7848e234', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "components/Menu/MenuLandingPageMobile.vue"
export default component.exports